<e11-panel [hasBorder]="true" [hasShadow]="false" [contentClassOverrides]="'e11-p-6'">
  <div class="e11-my-16 e11-text-center">
    <h1 class="e11-text-skin-light e11-text-6xl">4<span class="material-icons-outlined e11-text-5xl"> sentiment_dissatisfied </span>4</h1>
    <h3 class="e11-mb-8">{{ 'Page not found' | translate }}</h3>
    <p>{{ 'It appears the page you are looking for is unavailable.' | translate }}</p>
  </div>
</e11-panel>
